/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 4/23/14
 * Time: 9:33 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";
    var BaseModel = require("models/BaseModel");

    var UpgradeAccountModel = BaseModel.extend({
        defaults: {
            readAllButtonText: "",
            explanationText: "",
            disclaimerText: "",
            upgradeButtonText: ""
        },
        name: "UpgradeAccountModel",

        initialize: function (options) {
            this.readAllButtonText = options.readAllButtonText || "";
            this.explanationText = options.explanationText || "";
            this.disclaimerText = options.disclaimerText || "";
            this.upgradeButtonText = options.upgradeButtonText || "";
        }
    });

    return UpgradeAccountModel;
});
